import type { PayoutFee } from './PayoutDialog.types';

export const MIN_PAYOUT_AMOUNT_IN_MINOR_UNITS = 200;

export const calcFeeInMinorUnits = (amountInMinorUnits: number, fee: PayoutFee): number => Math.floor(amountInMinorUnits * fee.rate + fee.fixedValueInMinorUnits);
